/** @format */

import React, { FC } from "react";
import { Toast } from "react-bootstrap";
import { useDispatch } from "react-redux";
import { NotificationItem, setRemoveNotification } from "./notificationsSlice";
import TimeAgo from "react-timeago";
import { Markup } from "interweave";
import "./ToastItem.scss";

const ToastItem: FC<NotificationItem> = ({ id, msg, date, type, title }) => {
  const dispatch = useDispatch();
  const [show, setShow] = React.useState(true);
  const handleClose = () => {
    setShow(false);
    dispatch(setRemoveNotification(id));
  };

  return (
    <Toast
      className={`toast-${type}`}
      bg={type}
      id={id}
      show={show}
      onClose={handleClose}
      autohide={type !== "danger"}
      delay={5000}
    >
      <Toast.Header>
        <strong className="me-auto">{title}</strong>
        <small className="flex-shrink-0">
          <TimeAgo date={new Date(date)} />
        </small>
      </Toast.Header>
      <Toast.Body className="d-flex">
        <div>
          <strong className="me-auto">
            <Markup content={msg} />
          </strong>
          <br />
          <small>{id}</small>
        </div>
        {/* type === 'danger' && <Button className="ms-auto" variant="light">{_('Retry')}</Button> */}
      </Toast.Body>
    </Toast>
  );
};

export default ToastItem;
